import React, {Component} from "react"
import PropTypes from "prop-types"
import 'react-select-2/dist/css/react-select-2.css'
import Select from "react-select-2"
import shop from "../../shop/shop"

export default class Typeahead extends Component {
  constructor(props) {
    super(props)
  }

  static propTypes = {
    optionComponent: PropTypes.node, valueComponent: PropTypes.node, onSelect: PropTypes.func,
  }

  getOptions = (value) => {
    return shop.typeahead.loadWithProducts(value)
      .then(products => {
        if (!products || products.length === 0) return []
        return products.map(product => {
          return {value: product.article_nr, product, label: createLabel(product)}
        })
      })
      .then(options => {
        return {options}
      })
  }

  setValue = (value) => {
    if (this.props.onSelect) value = this.props.onSelect(value)
    return value
  }

  render() {
    let {setup} = this.props
    return (
      <Select.Async
        ref={setup}
        onChange={this.setValue}
        value={this.props.value}
        arrowRenderer={arrowRenderer}
        optionComponent={this.props.optionComponent || ProductOption}
        valueComponent={this.props.valueComponent || ProductValue}
        name="form-field-name"
        searchPromptText="Suche.."
        loadingPlaceholder="laden.."
        loadOptions={this.getOptions}
        placeholder={translate("product.articlenr")}
      />
    )
  }
}

Typeahead.propTypes = {
  setup: PropTypes.func
}

const arrowRenderer = () => <span>+</span>
const createLabel   = product => `${product.map_id} ${product.title}`

class ProductOption extends Component {
  constructor(props) {
    super(props)
  }

  static propTypes = {
    children:   PropTypes.node,
    className:  PropTypes.string,
    isDisabled: PropTypes.bool,
    isFocused:  PropTypes.bool,
    isSelected: PropTypes.bool,
    onFocus:    PropTypes.func,
    onSelect:   PropTypes.func,
    option:     PropTypes.object.isRequired,
  }

  handleMouseDown = (event) => {
    event.preventDefault()
    event.stopPropagation()
    this.props.onSelect(this.props.option, event)
  }

  handleMouseEnter = (event) => {
    this.props.onFocus(this.props.option, event)
  }

  handleMouseMove = (event) => {
    if (this.props.isFocused) return
    this.props.onFocus(this.props.option, event)
  }

  render() {
    let {product} = this.props.option
    return (
      <div className={this.props.className}
           onMouseDown={this.handleMouseDown}
           onMouseEnter={this.handleMouseEnter}
           onMouseMove={this.handleMouseMove}
           title={this.props.option.title}>
        <strong>{product.article_nr}</strong> {product.title}
        {/*{this.props.children}*/}
      </div>
    )
  }
}


class ProductValue extends Component {

  constructor(props) {
    super(props)
  }

  static propTypes = {
    children:   PropTypes.node,
    className:  PropTypes.string,
    isDisabled: PropTypes.bool,
    isFocused:  PropTypes.bool,
    isSelected: PropTypes.bool,
    onFocus:    PropTypes.func,
    onSelect:   PropTypes.func,
    option:     PropTypes.object,
  }

  render() {
    let {product} = this.props.value
    return (
      <div className="Select-value" title={product.title}>
				<span className="Select-value-label">
          <strong>{product.article_nr}</strong> {product.title}
				</span>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Typeahead/Typeahead.js